import styled from '@emotion/styled';
import { Button, colors, Tooltip, Typography } from '@ui-components/neo.tax';

import { ZIndex } from '@neo.tax/shared';

export const MergeButton = styled(Button)({
  minWidth: 198,
  margin: 0,
});

export const StyledTooltip = styled(Tooltip)({
  maxWidth: 300,
  width: 'auto',
  color: colors.gray[900], // Standard text color
  backgroundColor: colors.white, // Standard background color
  border: `1px solid ${colors.gray[200]}`,
  zIndex: ZIndex.MODAL, // Modal z-index
});

export const StyledTicketGroup = styled(Typography)({
  maxWidth: 150,
});

export const StyledTicketGroupList = styled.ul({
  margin: 0,
  paddingLeft: '20px',
  listStyleType: 'disc',
});
